import { mapState } from "vuex";
import config from "@/config/app-config";

export default {
  data() {
    return {
      paymentMethods: config.PAYMENT_METHODS,
    };
  },
  computed: {
    ...mapState({
      paymentData: (state) => state.customization.customization.economics,
    }),
    selectedPaymentMethod() {
      if (this.paymentData.paylands && this.paymentData.paylands.enabled)
        return this.paymentMethods.PAYLANDS.key;
      if (this.paymentData.mercadopago && this.paymentData.mercadopago.enabled)
        return this.paymentMethods.MERCADOPAGO.key;
      if (this.paymentData.mit && this.paymentData.mit.enabled)
        return this.paymentMethods.MIT.key;
      if (this.paymentData.pvs && this.paymentData.pvs.enabled)
        return this.paymentMethods.PVS.key;
    },
  },
  mounted() {
    if (!this.paymentData) {
      const context = this;
      this.$store.dispatch("getPaymentData", context);
    }
  },
};
